import * as React from 'react';

import { Button, Modal as AntModal } from 'antd';

type ModalProps = { isOpen: boolean; handleClose: () => void; children: React.ReactNode };

function Modal({ isOpen, handleClose, children }: ModalProps) {
  return (
    <AntModal
      data-testid='stepper-modal'
      open={isOpen}
      onCancel={handleClose}
      width='auto'
      footer={
        <div className='flex justify-end'>
          <Button type='text' onClick={handleClose}>
            Fechar
          </Button>
        </div>
      }
    >
      <div className='max-md:p-2'>{children}</div>
    </AntModal>
  );
}

export { Modal };
